import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=2927a11a&scoped=true&lang=pug"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=2927a11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927a11a",
  null
  
)

export default component.exports